import DataTable, { Alignment, PaginationOptions, TableProps } from 'react-data-table-component';
import { tableStyles } from '../../theme/data-table';
import { TablePagination } from './TablePagination';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { getDefaultPerPage, defaultRowsPerPageOptions, naturalSort, useRowExpand } from './table.helpers';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type VXTableProps<T> = TableProps<T> & {
  variant?: 'basic' | 'standard';
  idField?: keyof T;
  id?: string;
};

export const Table = <T,>(props: VXTableProps<T>): JSX.Element => {
  const { t } = useTranslation();
  const {
    id = '',
    variant = 'standard',
    idField = 'id' as keyof T,
    subHeaderAlign = Alignment.LEFT,
    ...tableProps
  } = props;
  const rowExpandProps = useRowExpand(props.expandableRows, idField);

  return (
    <DataTable
      keyField={idField as string}
      highlightOnHover
      pointerOnHover
      pagination
      paginationComponent={TablePagination}
      paginationComponentOptions={{ tableId: id } as PaginationOptions}
      paginationPerPage={getDefaultPerPage(id)}
      paginationRowsPerPageOptions={defaultRowsPerPageOptions}
      sortIcon={
        <ArrowDownwardIcon
          style={{
            fontSize: '16px',
            display: 'block',
            width: '16px',
            height: '16px',
            margin: '0 12px',
          }}
        />
      }
      customStyles={tableStyles(variant, tableProps.dense)}
      expandableIcon={{
        collapsed: <KeyboardArrowDownIcon />,
        expanded: <KeyboardArrowUpIcon />,
      }}
      expandOnRowClicked
      noDataComponent={<Typography padding="20px">{t('table.noData')}</Typography>}
      sortFunction={naturalSort}
      subHeaderAlign={subHeaderAlign}
      {...rowExpandProps}
      {...tableProps}
    />
  );
};
